import { render, staticRenderFns } from "./PanelCompetitionSettingStoperMain.vue?vue&type=template&id=b0d399b4&scoped=true&"
import script from "./PanelCompetitionSettingStoperMain.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStoperMain.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingStoperMain.vue?vue&type=style&index=0&id=b0d399b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d399b4",
  null
  
)

export default component.exports